var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Caption extends Component {
    constructor() {
        super('Caption', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            //$(window).on('resize', this.resize);
            $(window).on('scroll', this.inScreen);
            //this.resize();
            this.success();
        });
    }
    resize() {
        $('.component-caption').each((caption) => {
            if (caption.parents('.module-image-fullscreen').length > 0 || $(window).width() < 992)
                return;
            const imageAspectRatio = parseFloat(caption.data('imageAspectRatio'));
            const topPadding = parseInt(caption.parent().css('padding-top'));
            const leftPadding = parseInt(caption.parent().css('padding-left'));
            let top = 0, left = leftPadding, maxWidth = '100%';
            if (!isNaN(imageAspectRatio)) {
                const prev = caption.prev();
                const containerAspectRatio = prev.width() / prev.height();
                const prevWidth = prev.width();
                const prevHeight = prev.height();
                top = containerAspectRatio < imageAspectRatio ? topPadding + (prevWidth / imageAspectRatio) + (prevHeight - prevWidth / imageAspectRatio) / 2 : prevHeight + topPadding;
                left += containerAspectRatio > imageAspectRatio ? (prevWidth - prevHeight * imageAspectRatio) / 2 : 0;
                left -= caption.width() / 2;
                if (left < leftPadding)
                    left = leftPadding;
            }
            else if (caption.parents('.module-image-2-columns').length > 0) {
                const parentIndex = caption.parent().parent().index();
                const imgHeights = Array.from(caption.parents('.module-image-2-columns').find('img')).map((img) => $(img).height());
                if (imgHeights[0] > imgHeights[1]) {
                    left = maxWidth = parentIndex === 0 ? '100%' : '50%';
                }
                else if (imgHeights[0] == imgHeights[1]) {
                }
                else if (parentIndex === 1) {
                    caption.addClass('translate-middle-x');
                }
            }
            caption.css({ top, left, 'max-width': maxWidth });
        });
    }
    // add in-screen class to caption when it is in screen
    inScreen() {
        const factor = 2;
        $('.component-caption').each((caption) => {
            const padding = caption.height() * factor;
            if ((caption.viewportPosition().y > 0 && caption.viewportPosition().y < $(window).height() - padding) || (caption.position().y > $('body').height() - $(window).height() / 4)) {
                caption.addClass('in-screen');
            }
            else {
                caption.removeClass('in-screen');
            }
        });
    }
}
